import React from 'react';
import LocalImageOptimized from './LocalImageOptimized';

const LocalImage = ({ image, alt = image, classname = '' }) => (
	<LocalImageOptimized customClass={classname} imageUrl={image} alt={alt} />
);

export default LocalImage;
